import { Grid } from '@material-ui/core';
import { RedStyledGrid } from 'containers/AppContainer/Notifications/Bin';
import dangerIcon from 'images/danger-icon.svg';
import TimeAgo from 'timeago-react';

const AlertNotification = (props: { title: string; created_at: any }) => {
  return (
    <RedStyledGrid item>
      <Grid container direction={'row'} alignItems="center">
        <Grid item xs={1}>
          <img src={dangerIcon} style={{ marginRight: 2 }} alt="danger icon" />
        </Grid>
        <Grid item xs={7}>
          {props.title}
        </Grid>
        <RedStyledGrid item xs={4}>
          <TimeAgo datetime={props.created_at} locale="fr" />
        </RedStyledGrid>
      </Grid>
    </RedStyledGrid>
  );
};

export default AlertNotification;
